import Vue from 'vue';
import { debug } from '../utils';

export default {
  eventBus: {},
  state: {
    formValues: {},
    context: {}
  },
  setFormFieldValue(fieldKey, value) {
    debug.log('set form field', fieldKey, ':', value);
    const oldValue = this.state.formValues[fieldKey];
    Vue.set(this.state.formValues, fieldKey, value);
    // Listened on the FormWays component to change the v-model
    this.eventBus.$emit('value-changed', fieldKey, oldValue, value);
  },
  setContextValue(context, value) {
    debug.log('set context', context, ':', value);
    Vue.set(this.state.context, context, value);
  }
};
